import { createSelector } from 'reselect'

const slidesSelector = (state, props) => props.slides

export const total = createSelector(
  slidesSelector,
  (slides) => {
    return slides.length
  }
)